// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import scheduleApi from '~/apis/schedule';
import {
  CREATE_SCHEDULE,
  GET_SCHEDULE_DETAIL,
  DELETE_SCHEDULE,
  UPDATE_SCHEDULE,
  GET_SCHEDULE_DASHBOARD_LIST,
} from '~/utils/constants/actionType';
import {
  IBodyUpdateSchedule,
  IFormSchedule,
  IQueryParamSchedulesDashboard,
} from '~/utils/interface/schedule';
import { GET_SCHEDULE_LIST } from '~/utils/constants/actionType';
import { IParamSchedule } from '~/utils/interface/schedule';

export const createSchedule = createAsyncThunk(
  CREATE_SCHEDULE,
  async (payload: IFormSchedule, { rejectWithValue }) => {
    try {
      const resp = await scheduleApi.createSchedule(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getScheduleList = createAsyncThunk(
  GET_SCHEDULE_LIST,
  async (params: IParamSchedule, { rejectWithValue }) => {
    try {
      const resp = await scheduleApi.getScheduleList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getScheduleDashboardList = createAsyncThunk(
  GET_SCHEDULE_DASHBOARD_LIST,
  async (params: IQueryParamSchedulesDashboard, { rejectWithValue }) => {
    try {
      const resp = await scheduleApi.getScheduleDashboardList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteSchedule = createAsyncThunk(
  DELETE_SCHEDULE,
  async (scheduleId: string, { rejectWithValue }) => {
    try {
      const res = await scheduleApi.deleteSchedule(scheduleId);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getScheduleDetail = createAsyncThunk(
  GET_SCHEDULE_DETAIL,
  async (scheduleId: string, { rejectWithValue }) => {
    try {
      const resp = await scheduleApi.getScheduleDetail(scheduleId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateSchedule = createAsyncThunk(
  UPDATE_SCHEDULE,
  async (payload: IBodyUpdateSchedule, { rejectWithValue }) => {
    try {
      const resp = await scheduleApi.updateSchedule(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
